import { Controller } from "@hotwired/stimulus"

// Automatically scrolls to the top of the page after form submission
// This ensures flash messages are visible to the user
//
// Usage:
//   On the form element (or container):
//     data-controller="tax-organizer--scroll-to-flash"
//     data-action="turbo:submit-end->tax-organizer--scroll-to-flash#scroll"
//
export default class extends Controller {
  scroll(event) {
    // Scroll to top to see flash message
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
}
